var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('overview-title',[_vm._v("Keyword trends for ")]),(_vm.brand)?_c('keyword-trends',{attrs:{"brand":_vm.brand}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }